export default __webpack_public_path__ + "static/post-deco-left-d0f894935a889bdb05f75fad40bf8356.png";